import { Action } from 'redux';

import { IDataSourceDetailInfo, IDataSourceInfo } from '../../../datasource/models/IDataSourceInfo';
import { ChangeExtractDsToLive } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface ChangeExtractDsToLiveAction extends Action {
  datasources: IDataSourceInfo[] | IDataSourceDetailInfo[];
}

export function changeExtractDsToLive(datasources: IDataSourceInfo[] | IDataSourceDetailInfo[]): ChangeExtractDsToLiveAction {
  return {
    type: ChangeExtractDsToLive,
    datasources: datasources
  };
}

export const isChangeExtractDsToLiveAction = isActionFactory<ChangeExtractDsToLiveAction>(ChangeExtractDsToLive);
